export default "__VITE_ASSET__CEtgO0s5__"